module.exports = __webpack_public_path__ + "img/Faderen_Bilde-av-blomstrende-tre.c446af2f.jpg";